module.exports = __webpack_public_path__ + "img/img_app_taocan@3x.b7391305.png";